// For handling responses from the server
// and generating toast messages
export function formatErrorResponse(response) {
  const data = response.data;
  var text = '';
  for (var key in data) {
    // add space if multiple error messages
    if (text.length > 0) {
      text += ' ';
    }
    var error_messages = data[key];
    if (Array.isArray(error_messages)) {
      // It's an array of messages associated with the key
      for (var val of error_messages) {
        text += val?.[0]?.toUpperCase() + val?.slice(1);
      }
    } else if (error_messages) {
      // It's not an array, just a provided string which the identity
      // service may provide instead

      text +=
        error_messages?.toString()?.slice(0, 1)?.toUpperCase() +
        error_messages?.toString()?.slice(1);
    }
  }
  return text;
}

// When the server response is an error, we need to format the response
// body into a readable string.  Depending on the status code of the response,
// we need to handle the response data differently.
function toastErrorResponse(app, response) {
  if ([422, 429].includes(response.status)) {
    app.$toast.open({
      message: formatErrorResponse(response),
      // type: 'error',
      position: 'top-right',
      duration: 5000,
    });
  } else if (response.status == 504) {
    app.$toast.open({
      message: `The server response timed out.  Please try your request again.  If this error continues, please contact service@${process.env.SITE_DOMAIN}.`,
      // type: 'error',
      position: 'top-right',
      duration: '5000',
    });
  } else if (response.status == 502) {
    app.$toast.open({
      message: `The server response timed out.  Please try your request again.  If this error continues, please contact service@${process.env.SITE_DOMAIN}.`,
      // type: 'error',
      position: 'top-right',
      duration: 5000,
    });
  } else if (response.status == 403) {
    app.$toast.open({
      message: `Unable to perform the action requested (403).  If you received this message in error, please contact service@${process.env.SITE_DOMAIN}`,
      // type: 'error',
      position: 'top-right',
      duration: 5000,
    });
  } else {
    // Need to handle multiple error messages
    throw 'unsupported error response';
  }
}
// A successful toast response with the message provided
function toastSuccessResponse(app, message) {
  app.$toast.open({
    message: message,
    type: 'success',
    position: 'top-right',
    duration: 5000,
  });
}

// Return boolean indicating if the response was a success code
export function isSuccessfulServerResponse(response) {
  return [200, 201, 204, 206].includes(response?.status);
}

// Function to handle toasting the response in the case of both
// error and success; if successMessage is null then we skip showing a
// message
export function toastResponse(app, response, successMessage) {
  if (isSuccessfulServerResponse(response)) {
    if (successMessage && successMessage.length > 0) {
      return toastSuccessResponse(app, successMessage);
    } else {
      return true;
    }
  } else {
    return toastErrorResponse(app, response);
  }
}
